/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/**
 * Centralized Step Renderer - Single source of truth for all step rendering
 */
import React from 'react';

import FormBuilder from '../../../../components/FormBuilder/components/Form/FormBuilder';
import ATTRIBUTE_MAPPING_STEPS from '../../constants/CuaOnboardintConstants';
import { type StepName } from '../../data-layer/types';
import { useStepController } from '../../hooks/useStepController';
import type { ParsedField } from '../../utils/templateParsers';
import AttributeMappingContent from '../StepContent/AttributeMappingContent';

// Extended type for fields with validation
type ParsedFieldWithValidation = ParsedField & {
  hasError?: boolean;
  errorMessage?: string;
};

interface StepRendererProps {
  stepName: string;
  validationFields?: ParsedFieldWithValidation[];
  className?: string;
}

StepRenderer.defaultProps = {
  validationFields: [],
  className: '',
};

/**
 * Universal step renderer - handles all step types consistently
 */
function StepRenderer({
  stepName,
  validationFields = [],
  className = '',
}: StepRendererProps) {
  const { fields } = useStepController(stepName as StepName);

  const fieldsWithValidation =
    validationFields.length > 0
      ? fields.map((field) => {
          const validationField = validationFields.find(
            (vf) => vf.attributeName === field.attributeName
          );

          const mergedField = {
            ...field,
            hasError: (validationField as any)?.hasError ?? false,
            errorMessage: (validationField as any)?.errorMessage ?? '',
            fieldDisabled:
              (validationField as any)?.fieldDisabled ?? field.fieldDisabled,
          };

          return mergedField;
        })
      : fields;

  // AttributeMapping steps
  if (ATTRIBUTE_MAPPING_STEPS.includes(stepName)) {
    return <AttributeMappingContent stepName={stepName as any} />;
  }

  // FormBuilder steps
  return (
    <FormBuilder fields={fieldsWithValidation as any} className={className} />
  );
}

export default StepRenderer;
